import { render, staticRenderFns } from "./zoomable_component.vue?vue&type=template&id=207117d1&"
import script from "./zoomable_component.vue?vue&type=script&lang=js&"
export * from "./zoomable_component.vue?vue&type=script&lang=js&"
import style0 from "./zoomable_component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports